import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";

export default function TermsProvider() {
  const [content, setContent] = useState("");

  useEffect(() => {
    loadTerms();
  }, []);

  const loadTerms = async () => {
    try {
      const res = await axios.get(`${API}/admin/terms/active?type=provider`);
      setContent(res.data?.content || "Termos não disponíveis.");
    } catch (e) {
      setContent("Erro ao carregar termos.");
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: "40px auto", padding: 20 }}>
      <h1>Termos de Uso — Prestador</h1>
      <div style={{ whiteSpace: "pre-wrap" }} data-testid="provider-terms-content">{content}</div>
    </div>
  );
}
